// Jornadas por perfil — tom: produtores simples/direto, advogados formal, instituições técnico.
export const PROFILES = {
  "para-produtores": {
    slug: "para-produtores",
    profile: "Produtor rural",
    title: "Para produtores rurais | Melo Agro Engenharia",
    eyebrow: "Pelotas · Metade Sul do RS",
    h1: "Para produtores rurais",
    sub: "Soluções para produtores rurais, em Pelotas e Metade Sul do RS",
    intro: "Cuidamos da papelada e da técnica para você cuidar da lavoura e do gado. Crédito do Plano Safra, documentação da terra, renegociação de dívidas, seguro e atividade leiteira — tudo explicado do jeito simples, sem juridiquês.",
    waMsg: "Olá! Sou produtor rural e preciso de ajuda com a minha propriedade.",
    waCta: "Falar no WhatsApp",
    image: "/img/corn.webp",
    offerings: [
      { t: "Crédito do Plano Safra", d: "Custeio, investimento, Pronaf, Pronamp e RenovAgro, com projeto pronto para o banco e acompanhamento na safra.", link: "/credito-rural" },
      { t: "Regularização da propriedade", d: "CAR, CCIR e ITR — deixamos a documentação da terra em dia.", link: "/regularizacao-rural" },
      { t: "Renegociação de dívidas", d: "Dívida apertando? Montamos a renegociação com o banco com base na sua produção.", link: "/reestruturacao-de-dividas-rurais" },
      { t: "Seguro da lavoura", d: "Orientação na contratação do seguro e do Proagro, e vistoria na hora do sinistro.", link: "/seguro-agricola" },
      { t: "Valor da sua terra", d: "Avaliação do imóvel, das máquinas e dos equipamentos para vender, financiar ou dividir.", link: "/avaliacoes" },
    ],
    problems: [
      "O banco pediu um projeto técnico e você não sabe por onde começar",
      "A documentação do imóvel tem pendência e o crédito ficou travado",
      "A dívida da safra passada está apertando a próxima",
      "A lavoura perdeu para o clima e você não sabe se o seguro cobre",
      "O imóvel está no nome de quem já faleceu e precisa atualizar",
    ],
    howTitle: "Como funciona pedir nosso ajuda",
    steps: [
      { t: "Chame no WhatsApp", d: "Mande uma mensagem contando o que está precisando. Não precisa de nada formal." },
      { t: "Conversa sobre o caso", d: "Falamos sobre a sua situação e explicamos o que pode ser feito — sem compromisso." },
      { t: "Visita e documentos", d: "Vamos até a propriedade quando for preciso e cuidamos da papelada com você." },
      { t: "Entrega e acompanhamento", d: "Entregamos o documento pronto e continuamos do seu lado até resolver." },
    ],
  },

  "para-advogados": {
    slug: "para-advogados",
    profile: "Advogado(a)",
    title: "Perícia agronômica para advogados | Melo Agro",
    eyebrow: "Pelotas · Metade Sul do RS",
    h1: "Para advogados e escritórios",
    sub: "Perícia e assistência técnica agrícola para escritórios de advocacia, em Pelotas e Metade Sul do RS",
    intro: "Atuação técnica em processos rurais com embasamento, clareza e responsabilidade registrada: perícia judicial, assistência técnica, quesitos, pareceres e avaliações fundamentadas na NBR 14653, preparadas para o contraditório.",
    waMsg: "Olá! Sou advogado(a) e gostaria de enviar um processo para análise técnica.",
    waCta: "Enviar o processo para análise",
    image: "/img/inspect.webp",
    leadMagnet: {
      title: "Guia rápido: como pedir uma perícia agrícola",
      desc: "PDF curto com o passo a passo da contratação, os documentos que costumam ser pedidos e os tipos de disputa em que a perícia sustenta a prova.",
      file: "/materiais/guia-pericia-agricola.pdf",
    },
    offerings: [
      { t: "Perícia judicial e assistência técnica", d: "Atuação como perito do juízo ou assistente técnico da parte, com laudo e sustentação ao longo do processo.", link: "/pericias-judiciais" },
      { t: "Elaboração de quesitos", d: "Formulação técnica de quesitos e análise crítica dos quesitos da parte adversa." },
      { t: "Parecer técnico", d: "Pareceres com fundamentação técnica para instruir pedidos e defensas." },
      { t: "Avaliação para partilha, inventário e divórcio", d: "Avaliação de imóveis rurais e urbanos e de bens da atividade, conforme a ABNT NBR 14653.", link: "/avaliacoes" },
      { t: "Disputas de arrendamento e parceria", d: "Análise técnica de contratos e da atividade desenvolvida na área em disputa.", link: "/assessoria" },
      { t: "Quebra de safra e seguro", d: "Documentação técnica de perdas e pareceres sobre negativas de cobertura.", link: "/seguro-agricola" },
    ],
    problems: [
      "Laudos da outra parte com falhas técnicas que precisam ser apontadas",
      "Necessidade de perito com vivência real de campo na Metade Sul do RS",
      "Prazos processuais apertados para produção de prova técnica",
      "Quesitos mal formulados que enfraquecem a prova",
    ],
    howTitle: "Como contratar",
    steps: [
      { t: "Envio do processo", d: "O senhor envia os autos ou as informações do caso para análise preliminar." },
      { t: "Análise de viabilidade", d: "Devolvemos uma leitura técnica do caso, com sugestão de quesitos e caminho probatório." },
      { t: "Vistoria e produção do laudo", d: "Realizamos a vistoria, o levantamento de dados e a elaboração do laudo ou parecer." },
      { t: "Sustentação técnica", d: "Acompanhamos o processo, respondendo quesitos e apoiando a Advocacia até a decisão." },
    ],
  },

  "para-instituicoes-financeiras": {
    slug: "para-instituicoes-financeiras",
    profile: "Banco ou cooperativa",
    title: "Laudos para bancos e cooperativas | Melo Agro",
    eyebrow: "Pelotas · Metade Sul do RS",
    h1: "Para bancos e cooperativas",
    sub: "Laudos de avaliação de garantias e vistorias para instituições financeiras, em Pelotas e Metade Sul do RS",
    intro: "Suporte técnico à carteira de crédito rural: laudos de avaliação de garantias de imóveis, máquinas e equipamentos, laudos técnicos agronômicos e laudos de sinistro, com padrão técnico e responsabilidade registrada.",
    waMsg: "Olá! Represento uma instituição financeira e gostaria de conversar sobre laudos e avaliações.",
    waCta: "Falar com a equipe",
    image: "/img/farm-aerial.webp",
    offerings: [
      { t: "Laudo de avaliação de garantias — imóveis", d: "Avaliação de imóveis rurais e urbanos conforme a ABNT NBR 14653, para garantia de crédito rural.", link: "/avaliacoes" },
      { t: "Laudo de avaliação — máquinas e equipamentos", d: "Identificação completa do bem (marca, modelo, série, ano, horímetro), estado de conservação e pesquisa de mercado, para penhor de máquinas.", link: "/avaliacoes" },
      { t: "Laudos técnicos agronômicos", d: "Laudos claros e fundamentados para análise de operações e esclarecimentos técnicos.", link: "/laudos-tecnicos" },
      { t: "Laudos de sinistro", d: "Documentação técnica de perdas para processos de seguro e Proagro.", link: "/seguro-agricola" },
    ],
    problems: [
      "Operações travadas por laudo de garantia ausente ou fora de padrão",
      "Bens de penhor sem identificação técnica suficiente",
      "Dificuldade de acompanhar a aplicação do crédito nas propriedades da região",
      "Sinistros que chegam sem documentação técnica mínima",
    ],
    howTitle: "Como trabalhamos com a instituição",
    steps: [
      { t: "Solicitação", d: "A instituição encaminha a operação com os dados do cliente e do bem." },
      { t: "Vistoria e levantamento", d: "Visita à propriedade com coleta de dados, medições e registro fotográfico." },
      { t: "Laudo no padrão acordado", d: "Documento técnico conforme a ABNT NBR 14653, com responsável técnico registrado no CREA-RS." },
      { t: "Entrega e sustentação", d: "Entrega do laudo ao analista e suporte técnico a eventuais questionamentos." },
    ],
    deliveryTitle: "Prazos e padrão de entrega",
    delivery: [
      { t: "Formato", d: "Laudo em PDF, com fotos, memória de cálculo e identificação completa do bem ou do imóvel." },
      { t: "Metodologia", d: "ABNT NBR 14653, com definição do critério de avaliação conforme a finalidade da operação." },
      { t: "Responsabilidade", d: "Responsável técnico engenheiro civil e agrônomo, CREA-RS 244.373; empresa Melo Agro Engenharia Ltda., CREA PJ 253.838." },
    ],
  },
};

export const PROFILE_SLUGS = Object.keys(PROFILES);

export const PROFILE_OPTIONS = [
  { slug: "produtor-rural", label: "Produtor rural" },
  { slug: "advogada", label: "Advogado(a)" },
  { slug: "banco", label: "Banco ou cooperativa" },
  { slug: "outro", label: "Outro" },
];

// Mapeia o parâmetro ?perfil= da URL para a opção do formulário
export const PROFILE_FROM_PARAM = {
  produtores: "Produtor rural",
  advogados: "Advogado(a)",
  instituicoes: "Banco ou cooperativa",
};
